import { channelColorMap } from '@op/constants';
import { SymbolType } from '@op/constants/chart';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import {
  getWeekly_OverView_ChannelChart,
  getWeekly_OverView_LanguageChart,
} from '@op/services';
import { DBO_REQ } from '@op/utils/format';
import { TRequestBackType } from '@op/utils/requestUtil';
import { useEffect, useMemo, useState } from 'react';

export function useOverviewStateChart({
  filter,
  type,
  metric,
  chartType,
  setWeeklyData,
}: {
  filter: any;
  type: 'channel' | 'language';
  metric: string;
  chartType?: SymbolType;
  setWeeklyData?: (data: any) => void;
}) {
  const [lineData, setLineData] = useState<null | TRequestBackType>(null);
  const [pieData, setPieData] = useState<null | {
    isEmpty: boolean;
    total: number;
    legend: Array<string>;
    data: Array<{ name: string; value: number }>;
  }>(null);
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
    clear: () => {
      setLineData(null);
      setPieData(null);
    },
  });

  function request() {
    const func =
      type === 'channel'
        ? getWeekly_OverView_ChannelChart
        : getWeekly_OverView_LanguageChart;
    wrapperCancelRequest(func, {
      ...filter,
      metric, 
    }).then(data => {
      const {
        list,
        this_week_list,
        timeline_of_end_time,
        timeline_of_start_time,
        avg_five_week,
        this_week,
        avg_five_week_time,
        this_week_time,
      } = data || {};

      const lineData = DBO_REQ.listKeys(
        { timeline: list, key: 'key', valueKey: 'val' },
        {
          timeline_of_start_time,
          timeline_of_end_time,
          filter,
        },
      );

      let total = 0;
      const legend: Array<string> = [];
      const pieData = (this_week_list || []).map((item: any) => {
        total = total + item.val;
        legend.push(item.key);

        let obj: any = { name: item.key, value: item.val };

        if (item.key === 'other') {
          obj = { ...obj, legend };
        }

        if (type === 'channel') {
          return {
            ...obj,
            itemStyle: {
              color: channelColorMap[item.key],
            },
          };
        }
        return obj;
      });
      setWeeklyData?.({
        avg_five_week,
        this_week,
        avg_five_week_time,
        this_week_time,
      });
      setLineData(lineData);
      setPieData({ data: pieData, total, legend, isEmpty: total === 0 });
    });
  }

  const isEmpty = useMemo(() => {
    if (chartType === 'line') {
      return lineData === null || lineData.isEmpty;
    }

    return pieData === null || pieData.isEmpty;
  }, [chartType, lineData, pieData]);

  useEffect(() => {
    request();
  }, []);

  return { lineData, pieData, loading, isEmpty };
}
